<template></template>

<script>
export default {
  name: "sub_join-module1",
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>